export default "__VITE_ASSET__mQJALyYd__"